<template>

  <div>
    <Modal
      :title="title"
      :submit-button="false"
    >

      <AsyncPanel :status="initStatus">

        <v-expansion-panels variant="accordion">

          <v-expansion-panel
            v-for="win in breakdownData.windows"
          >

            <v-expansion-panel-title>

              <div class="breakdowns">
                <div>{{ moment(win.start).format('hh:mm a') }} – {{ moment(win.end).format('hh:mm a') }}</div>
                <div class="text-right">
                  {{ win.spacesSold }}/{{ win.spacesTotal }}
                </div>
              </div>

            </v-expansion-panel-title>

            <v-expansion-panel-text>

              <div class="breakdowns">
                <template v-for="(spacesSold, channel) in getSpacesSoldByChannel(win)" class="d-flex">
                  <div>{{ ChannelRegistry.find(channel)?.titleShort ?? channel }}</div>
                  <div class="text-right">{{ spacesSold }}</div>
                </template>
              </div>

            </v-expansion-panel-text>

          </v-expansion-panel>

        </v-expansion-panels>

      </AsyncPanel>

    </Modal>
  </div>

</template>

<script setup>

import { computed, onBeforeMount, ref } from 'vue'

// components
import AsyncPanel from '../../../AsyncPanel.vue'

// models
import LocationProduct from '../../../../models/LocationProduct'

// misc
import InventoryApi from '../../../../services/api-clients/InventoryApi'
import asyncStatus from '../../../../utils/asyncStatus'
import NotificationService from '../../../../services/NotificationService'
import moment from 'moment'
import ChannelRegistry from '../../../../channels/ChannelRegistry'

const props = defineProps({

  locationID: {
    type: Number,
    required: true,
  },

  locationProductID: {
    type: Number,
    required: true,
  },

  date: {
    type: Date,
    required: true,
  },

})

const title = computed(() => {
  const locationProduct = LocationProduct.query().with(['product']).whereId(props.locationProductID).first()
  const productName = locationProduct && locationProduct.product ? locationProduct.product.name : '(unknown)'
  return `${productName} – ${moment(props.date).format('MM/DD/YYYY')}`
})

const breakdownData = ref(null)

/**
 * Initialization
 */

const initStatus = asyncStatus()

onBeforeMount(() => {

  initStatus.setBusy()

  const formattedDate = moment(props.date).format(moment.HTML5_FMT.DATE)

  InventoryApi.getWindows(props.locationID, formattedDate, props.locationProductID)
  .then((response) => {
    breakdownData.value = response
    initStatus.setReady()
  })
  .catch((error) => {
    console.error(error)
    initStatus.setError(error)
    NotificationService.error(error)
  })

})

/**
 *
 */

function getSpacesSoldByChannel(win) {
  const output = {}
  win.locationProducts.forEach((lp) => {
    Object.entries(lp.spacesSoldPerChannel).forEach(([channel, spacesSold]) => {
      if (!(channel in output)) {
        output[channel] = 0
      }
      output[channel] += spacesSold
    })
  })
  return output
}

</script>

<style lang="scss">

.breakdowns {
  display: grid;
  grid-template-columns: [label] 210px [value] 72px [end];
  row-gap: 10px;
}

</style>
